import imgscroll from './img-scroll'
import './categories-slider'